export default class ResourceTopicDto {
    /**
     * @type{number}
     */
    id;

    /**
     * @type{string}
     */
    name;

    constructor(id, name) {
        this.id = id;
        this.name = name;
    }

}
